import * as React from 'react'

import { Trash } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../../../app/_providers/LocalizationProvider.client'
import { trackEvent } from '../../../../../lib/analytics'
import { intlPrettyCurrency } from '../../../../../lib/utils'

import {
  DeleteIconButton,
  DeleteIconColumn,
  FullPrice,
  Price,
  PriceRow,
  ValuePrice,
} from './styles'

export const Template: React.FC<{
  displayDiscountAsValue?: boolean
  effectivePrice: number | undefined
  eventCategory?: 'minicart' | 'cart'
  fullPrice: number | undefined
  removeItem?: () => void
  title?: string
  valueSignalLabel: string
}> = ({
  displayDiscountAsValue = false,
  effectivePrice,
  eventCategory = '',
  fullPrice,
  removeItem,
  title = '',
  valueSignalLabel,
}) => {
  const { locale, region } = useLocalization()
  const isOnSale = fullPrice !== effectivePrice

  return (
    <>
      <PriceRow>
        {isOnSale &&
          (displayDiscountAsValue ? (
            <ValuePrice>
              {intlPrettyCurrency({
                value: fullPrice,
                unit: 'cents',
                region: region,
                locale: locale,
              })}{' '}
              {valueSignalLabel}
            </ValuePrice>
          ) : (
            <FullPrice>
              {intlPrettyCurrency({
                value: fullPrice,
                unit: 'cents',
                region: region,
                locale: locale,
              })}
            </FullPrice>
          ))}
        <Price
          $displayDiscountAsValue={displayDiscountAsValue}
          $isSalePrice={isOnSale}
          data-testid='price-and-delete-button-price'
        >
          {intlPrettyCurrency({
            value: effectivePrice,
            unit: 'cents',
            region: region,
            locale: locale,
          })}
        </Price>
      </PriceRow>

      {title && (
        <DeleteIconColumn>
          <DeleteIconButton
            {...trackEvent({
              category: eventCategory,
              action: 'remove item from cart',
              label: title,
            })}
            onClick={removeItem}
            aria-label={`Remove item: ${title}`}
          >
            <Trash stroke='currentColor' />
          </DeleteIconButton>
        </DeleteIconColumn>
      )}
    </>
  )
}
